import { render } from "./Right.vue?vue&type=template&id=7c2d4893"
const script = {}

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__